import { render } from "./UpdateDnsZone.vue?vue&type=template&id=48103a6a&scoped=true"
import script from "./UpdateDnsZone.vue?vue&type=script&lang=js"
export * from "./UpdateDnsZone.vue?vue&type=script&lang=js"

import "./UpdateDnsZone.vue?vue&type=style&index=0&id=48103a6a&lang=less&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48103a6a"]])

export default __exports__